export const actionTypes = {
    SAGA_FETCH_PRODUCT_DETAILS: 'SAGA_FETCH_PRODUCT_DETAILS',
    FETCH_PRODUCT_DETAILS_SUCCESS: 'FETCH_PRODUCT_DETAILS_SUCCESS',
    SAGA_UPDATE_PRODUCT_DETAILS: 'SAGA_UPDATE_PRODUCT_DETAILS',
    UPDATE_PRODUCT_DETAILS_SUCCESS: 'UPDATE_PRODUCT_DETAILS_SUCCESS',
    SAGA_IMPORT_PRODUCT: 'SAGA_IMPORT_PRODUCT',
    PRODUCT_LOADING_START: 'PRODUCT_LOADING_START',
    PRODUCT_LOADING_END: 'PRODUCT_LOADING_END',
    SAGA_FETCH_IMPORTED_PRODUCTS: 'SAGA_FETCH_IMPORTED_PRODUCTS',
    FETCH_IMPORTED_PRODUCTS_SUCCESS: 'FETCH_IMPORTED_PRODUCTS_SUCCESS',
    SAGA_DELETE_IMPORTED_PRODUCTS: 'SAGA_DELETE_IMPORTED_PRODUCTS',
    SAGA_ADD_NEW_PRODUCT: 'SAGA_ADD_NEW_PRODUCT',
    ADD_NEW_PRODUCT_SUCCESS: 'ADD_NEW_PRODUCT_SUCCESS',
    SAGA_FETCH_PRODUCT_BY_DRAFT_ID: 'SAGA_FETCH_PRODUCT_BY_DRAFT_ID',
    SAGA_UPDATE_PRODUCT_INFO: 'SAGA_UPDATE_PRODUCT_INFO',
    SAGA_FETCH_PRODUCT_IMAGES: 'SAGA_FETCH_PRODUCT_IMAGES',
    UPDATE_PRODUCT_INFO_SUCCESS: 'UPDATE_PRODUCT_INFO_SUCCESS',
    UPDATE_PRODUCT_ID_SLINS: 'UPDATE_PRODUCT_ID_SLINS',
    PRE_POPULATE_PRODUCT_IMAGES: 'PRE_POPULATE_PRODUCT_IMAGES',
    SET_PRODUCT_AVAILABLE_IMAGES: 'SET_PRODUCT_AVAILABLE_IMAGES',
    CLEAR_PRODUCT_AVAILABLE_IMAGES: 'CLEAR_PRODUCT_AVAILABLE_IMAGES',
    START_PRODUCT_IMAGE_LOADING: 'START_PRODUCT_IMAGE_LOADING',
    STOP_PRODUCT_IMAGE_LOADING: 'STOP_PRODUCT_IMAGE_LOADING',
    SAGA_PATCH_PRODUCT_DETAILS: 'SAGA_PATCH_PRODUCT_DETAILS',
    PATCH_PRODUCT_DETAILS_SUCCESS: 'PATCH_PRODUCT_DETAILS_SUCCESS',
    SET_PRODUCT_ERROR: 'SET_PRODUCT_ERROR',
    SET_NUTRITION_CONTAINS: 'SET_NUTRITION_CONTAINS',
    CONTAINS_LOADING_START: 'CONTAINS_LOADING_START',
    CONTAINS_LOADING_END: 'CONTAINS_LOADING_END',
    SAGA_FETCH_CONTAINS: 'SAGA_FETCH_CONTAINS',
    SAGA_UPDATE_SECTION_FLAG: 'SAGA_UPDATE_SECTION_FLAG',
    SET_SECTION_FLAG: 'SET_SECTION_FLAG',
    SAGA_FETCH_PRIMARY_CATEGORIES: 'SAGA_FETCH_PRIMARY_CATEGORIES',
    SAGA_FETCH_DYNAMIC_CATEGORIES: 'SAGA_FETCH_DYNAMIC_CATEGORIES',
    SAGA_FETCH_TAGS: 'SAGA_FETCH_TAGS',
    FETCH_TAGS_SUCCESS: 'FETCH_TAGS_SUCCESS',
    OPTIONS_LOADING_START: 'OPTIONS_LOADING_START',
    OPTIONS_LOADING_END: 'OPTIONS_LOADING_END',
    CLEAR_COMPLETED_MODAL: 'CLEAR_COMPLETED_MODAL',
    SAGA_FETCH_MARKETPLACES: 'SAGA_FETCH_MARKETPLACES',
    FETCH_MARKETPLACES_SUCCESS: 'FETCH_MARKETPLACES_SUCCESS',
    SAGA_FETCH_SERVING_SIZE_UOM: 'SAGA_FETCH_SERVING_SIZE_UOM',
    FETCH_SERVING_SIZE_UOM_SUCCESS: 'FETCH_SERVING_SIZE_UOM_SUCCESS',
    SAGA_FETCH_EQUIPMENTS: 'SAGA_FETCH_EQUIPMENTS',
    FETCH_EQUIPMENTS_SUCCESS: 'FETCH_EQUIPMENTS_SUCCESS',
    TOGGLE_PRODUCT_PATCH_SUCCESS: 'TOGGLE_PRODUCT_PATCH_SUCCESS',
    SAGA_UPDATE_PRODUCT_NAME: 'SAGA_UPDATE_PRODUCT_NAME',
    UPDATE_PRODUCT_NAME_SUCCESS: 'UPDATE_PRODUCT_NAME_SUCCESS',
    TOGGLE_PRODUCT_NAME_SUCCESS: 'TOGGLE_PRODUCT_NAME_SUCCESS',
    SET_EDIT_CONFIRMATION: 'SET_EDIT_CONFIRMATION',
    CLEAR_EDIT_CONFIRMATION: 'CLEAR_EDIT_CONFIRMATION',
    SAGA_PUBLISH_PRODUCT: 'SAGA_PUBLISH_PRODUCT',
    PUBLISH_PRODUCT_SUCCESS: 'PUBLISH_PRODUCT_SUCCESS',
    CLEAR_PUBLISH_ALERT: 'CLEAR_PUBLISH_ALERT',
    SAGA_DELETE_PRODUCT: 'SAGA_DELETE_PRODUCT',
    CLEAR_SAVED_SECTION: 'CLEAR_SAVED_SECTION',

    UPDATE_PRODUCTS_FILTERS: 'UPDATE_PRODUCTS_FILTERS',
    CLEAR_PRODUCTS_FILTERS: 'CLEAR_PRODUCTS_FILTERS',

    CLEAR_MANAGE_UPDATES_FILTERS: 'CLEAR_MANAGE_UPDATES_FILTERS',
    UPDATE_MANAGE_UPDATE_FILTERS: 'UPDATE_MANAGE_UPDATE_FILTERS',

    SAGA_FETCH_MANAGE_UPDATES: 'SAGA_FETCH_MANAGE_UPDATES',
    FETCH_MANAGE_UPDATES_SUCCESS: 'FETCH_MANAGE_UPDATES_SUCCESS',

    SAGA_UPDATE_PUBLISH_PRODUCT: 'SAGA_UPDATE_PUBLISH_PRODUCT',
    SET_ADD_PRODUCTS_SWITCH: 'SET_ADD_PRODUCTS_SWITCH',
    SAGA_BULK_PUBLISH_PRODUCTS: 'SAGA_BULK_PUBLISH_PRODUCTS',
    BULK_PUBLISH_PRODUCTS_SUCCESS: 'BULK_PUBLISH_PRODUCTS_SUCCESS',
    RESET_FAILED_PRODUCTS: 'RESET_FAILED_PRODUCTS',
    SAGA_FETCH_MODIFIED_AREAS: 'SAGA_FETCH_MODIFIED_AREAS',
    SAGA_FETCH_MANAGE_PRODUCTS: 'SAGA_FETCH_MANAGE_PRODUCTS',
    FETCH_MANAGE_PRODUCTS_SUCCESS: 'FETCH_MANAGE_PRODUCTS_SUCCESS',
    UPDATE_MANAGE_PRODUCTS_FILTERS: 'UPDATE_MANAGE_PRODUCTS_FILTERS',
    SET_MANAGE_UPDATES_ALERT: 'SET_MANAGE_UPDATES_ALERT',
    CLEAR_MANAGE_UPDATES_ALERT: 'CLEAR_MANAGE_UPDATES_ALERT',
    SAGA_FETCH_PRODUCT_BY_ID: 'SAGA_FETCH_PRODUCT_BY_ID',
    SAGA_BULK_UPDATE_CATALOG_PRODUCTS: 'SAGA_BULK_UPDATE_CATALOG_PRODUCTS',
    BULK_UPDATE_CATALOG_PRODUCTS_SUCCESS: 'BULK_UPDATE_CATALOG_PRODUCTS_SUCCESS',
    SAGA_UPDATE_CATALOG_PRODUCT: 'SAGA_UPDATE_CATALOG_PRODUCT',
    TOGGLE_MODIFIED_AREA_AUTO_UPDATE: 'TOGGLE_MODIFIED_AREA_AUTO_UPDATE',
    UNMOUNT_PRODUCT: 'UNMOUNT_PRODUCT',
}

export const setManageUpdatesAlert = msg => ({
    type: actionTypes.SET_MANAGE_UPDATES_ALERT,
    payload: msg,
})

export const clearManageUpdatesAlert = () => ({
    type: actionTypes.CLEAR_MANAGE_UPDATES_ALERT,
})

export const setAddProductsSwitch = payload => ({
    type: actionTypes.SET_ADD_PRODUCTS_SWITCH,
    payload,
})

export const sagaFetchManageUpdates = payload => ({
    type: actionTypes.SAGA_FETCH_MANAGE_UPDATES,
    payload,
})

export const fetchManageUpdatesSuccess = data => ({
    type: actionTypes.FETCH_MANAGE_UPDATES_SUCCESS,
    payload: data,
})

export const sagaFetchProductDetails = productId => ({
    type: actionTypes.SAGA_FETCH_PRODUCT_DETAILS,
    payload: productId,
})

export const fetchProductDetailsSuccess = payload => ({
    type: actionTypes.FETCH_PRODUCT_DETAILS_SUCCESS,
    payload,
})

export const sagaPatchProductDetails = (payload, options) => ({
    type: actionTypes.SAGA_PATCH_PRODUCT_DETAILS,
    payload,
    options,
})

export const patchProductDetailsSuccess = (payload, key) => ({
    type: actionTypes.PATCH_PRODUCT_DETAILS_SUCCESS,
    payload,
    key,
})

export const clearSavedSection = () => ({
    type: actionTypes.CLEAR_SAVED_SECTION,
})

export const sagaImportProduct = payload => ({
    type: actionTypes.SAGA_IMPORT_PRODUCT,
    payload,
})

export const productLoadingStart = () => ({
    type: actionTypes.PRODUCT_LOADING_START,
})

export const productLoadingEnd = () => ({
    type: actionTypes.PRODUCT_LOADING_END,
})

export const fetchImportedProducts = payload => ({
    type: actionTypes.SAGA_FETCH_IMPORTED_PRODUCTS,
    payload,
})

export const fetchImportedProductsSuccess = payload => ({
    type: actionTypes.FETCH_IMPORTED_PRODUCTS_SUCCESS,
    payload,
})

export const sagaDeleteImportedProducts = payload => ({
    type: actionTypes.SAGA_DELETE_IMPORTED_PRODUCTS,
    payload,
})

export const sagaAddNewProduct = payload => ({
    type: actionTypes.SAGA_ADD_NEW_PRODUCT,
    payload,
})

export const addNewProductSuccess = payload => ({
    type: actionTypes.ADD_NEW_PRODUCT_SUCCESS,
    payload,
})

export const sagaFetchProductByDraftId = payload => ({
    type: actionTypes.SAGA_FETCH_PRODUCT_BY_DRAFT_ID,
    payload,
})

export const updateProductInfo = payload => ({
    type: actionTypes.UPDATE_PRODUCT_INFO,
    payload,
})

export const updateProductIDSlins = payload => ({
    type: actionTypes.UPDATE_PRODUCT_ID_SLINS,
    payload,
})

export const sagaFetchProductImages = productID => ({
    type: actionTypes.SAGA_FETCH_PRODUCT_IMAGES,
    payload: productID,
})

export const setPrePopulateProductImagesFlag = state => ({
    type: actionTypes.PRE_POPULATE_PRODUCT_IMAGES,
    payload: state,
})

export const setProductAvailableImages = images => ({
    type: actionTypes.SET_PRODUCT_AVAILABLE_IMAGES,
    payload: images,
})

export const startProductImageLoading = () => ({
    type: actionTypes.START_PRODUCT_IMAGE_LOADING,
})

export const clearProductImages = () => ({
    type: actionTypes.CLEAR_PRODUCT_AVAILABLE_IMAGES,
})

export const stopProductImageLoading = () => ({
    type: actionTypes.STOP_PRODUCT_IMAGE_LOADING,
})

export const setProductError = payload => ({
    type: actionTypes.SET_PRODUCT_ERROR,
    payload,
})

export const setNutritionContains = payload => ({
    type: actionTypes.SET_NUTRITION_CONTAINS,
    payload,
})

export const containsLoadingStart = () => ({
    type: actionTypes.CONTAINS_LOADING_START,
})

export const containsLoadingEnd = () => ({
    type: actionTypes.CONTAINS_LOADING_END,
})

export const sagaFetchContains = () => ({
    type: actionTypes.SAGA_FETCH_CONTAINS,
})

export const sagaUpdateSectionFlag = payload => ({
    type: actionTypes.SAGA_UPDATE_SECTION_FLAG,
    payload,
})

export const setSectionFlag = payload => ({
    type: actionTypes.SET_SECTION_FLAG,
    payload,
})

export const sagaFetchPrimaryCategories = () => ({
    type: actionTypes.SAGA_FETCH_PRIMARY_CATEGORIES,
})

export const sagaFetchDynamicCategories = () => ({
    type: actionTypes.SAGA_FETCH_DYNAMIC_CATEGORIES,
})

export const sagaFetchTags = () => ({
    type: actionTypes.SAGA_FETCH_TAGS,
})

export const fetchTagsSuccess = payload => ({
    type: actionTypes.FETCH_TAGS_SUCCESS,
    payload,
})

export const optionsLoadingStart = payload => ({
    type: actionTypes.OPTIONS_LOADING_START,
    payload,
})

export const optionsLoadingEnd = () => ({
    type: actionTypes.OPTIONS_LOADING_END,
})

export const clearCompletedModal = () => ({
    type: actionTypes.CLEAR_COMPLETED_MODAL,
})

export const sagaFetchProductsMarketplaces = payload => ({
    type: actionTypes.SAGA_FETCH_MARKETPLACES,
    payload,
})

export const fetchMarketplacesSuccess = payload => ({
    type: actionTypes.FETCH_MARKETPLACES_SUCCESS,
    payload,
})

export const sagaFetchServingSizeUOM = () => ({
    type: actionTypes.SAGA_FETCH_SERVING_SIZE_UOM,
})

export const fetchServingSizeUOMSuccess = payload => ({
    type: actionTypes.FETCH_SERVING_SIZE_UOM_SUCCESS,
    payload,
})

export const sagaFetchEquipments = () => ({
    type: actionTypes.SAGA_FETCH_EQUIPMENTS,
})

export const fetchEquipmentsSuccess = payload => ({
    type: actionTypes.FETCH_EQUIPMENTS_SUCCESS,
    payload,
})

export const sagaUpdateProductName = payload => ({
    type: actionTypes.SAGA_UPDATE_PRODUCT_NAME,
    payload,
})

export const updateProductNameSuccess = payload => ({
    type: actionTypes.UPDATE_PRODUCT_NAME_SUCCESS,
    payload,
})

export const toggleUpdateProductName = () => ({
    type: actionTypes.TOGGLE_PRODUCT_NAME_SUCCESS,
})

export const setEditConfirmation = callback => ({
    type: actionTypes.SET_EDIT_CONFIRMATION,
    payload: callback,
})

export const clearEditConfirmation = () => ({
    type: actionTypes.CLEAR_EDIT_CONFIRMATION,
})

export const toggleProductsPatchSuccess = () => ({
    type: actionTypes.TOGGLE_PRODUCT_PATCH_SUCCESS,
})

export const sagaPublishProduct = environment => ({
    type: actionTypes.SAGA_PUBLISH_PRODUCT,
    payload: environment,
})

export const publishSuccess = payload => ({
    type: actionTypes.PUBLISH_PRODUCT_SUCCESS,
    payload,
})

export const clearPublishAlert = () => ({
    type: actionTypes.CLEAR_PUBLISH_ALERT,
})

export const sagaDeleteProduct = payload => ({
    type: actionTypes.SAGA_DELETE_PRODUCT,
    payload,
})

export const updateProductsFilters = payload => ({
    type: actionTypes.UPDATE_PRODUCTS_FILTERS,
    payload,
})

export const clearProductFilters = () => ({
    type: actionTypes.CLEAR_PRODUCTS_FILTERS,
})

export const clearManageUpdatesFilter = () => ({
    type: actionTypes.CLEAR_MANAGE_UPDATES_FILTERS,
})

export const updateManageUpdatesFilter = payload => ({
    type: actionTypes.UPDATE_MANAGE_UPDATE_FILTERS,
    payload,
})

export const sagaUpdatePublishedProduct = id => ({
    type: actionTypes.SAGA_UPDATE_PUBLISH_PRODUCT,
    payload: id,
})

export const sagaBulkPublishProducts = payload => ({
    type: actionTypes.SAGA_BULK_PUBLISH_PRODUCTS,
    payload,
})

export const bulkPublishProductsSuccess = payload => ({
    type: actionTypes.BULK_PUBLISH_PRODUCTS_SUCCESS,
    payload,
})

export const resetFailedProducts = () => ({
    type: actionTypes.RESET_FAILED_PRODUCTS,
})
export const sagaFetchModifiedAreas = () => ({
    type: actionTypes.SAGA_FETCH_MODIFIED_AREAS,
})

export const sagaFetchManageProducts = payload => ({
    type: actionTypes.SAGA_FETCH_MANAGE_PRODUCTS,
    payload,
})

export const fetchManageProductsSuccess = data => ({
    type: actionTypes.FETCH_MANAGE_PRODUCTS_SUCCESS,
    payload: data,
})

export const sagaFetchProductById = payload => ({
    type: actionTypes.SAGA_FETCH_PRODUCT_BY_ID,
    payload,
})

export const sagaBulkUpdateCatalogProducts = payload => ({
    type: actionTypes.SAGA_BULK_UPDATE_CATALOG_PRODUCTS,
    payload,
})

export const bulkUpdateCatalogProductsSuccess = payload => ({
    type: actionTypes.BULK_UPDATE_CATALOG_PRODUCTS_SUCCESS,
    payload,
})

export const toggleModifiedAreaAutoUpdate = payload => ({
    type: actionTypes.TOGGLE_MODIFIED_AREA_AUTO_UPDATE,
    payload,
})

export const unMountProduct = () => ({
    type: actionTypes.UNMOUNT_PRODUCT,
})
